import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { CHANGE_REQUEST_STATUS } from "constants/financialClosing";
import { DISPLAY_DATE_HH_MM_A } from "constants/date";
import dayjs from "dayjs";
import { ClosingChangeRequest } from "store/apis/financialClosing";

type ChangeRequestsAccordionProps = {
  changeRequests: ClosingChangeRequest[];
};

const ACCORDION_VALUE = "CHANGE_REQUESTS";

const ChangeRequestItem = ({
  changeRequest,
}: {
  changeRequest: ClosingChangeRequest;
}) => {
  const isPending = changeRequest.status === CHANGE_REQUEST_STATUS.PENDING;
  const createdAt = dayjs(changeRequest.created_at).format(
    DISPLAY_DATE_HH_MM_A
  );
  const requestedBy = changeRequest.created_by.name
    ? `${changeRequest.created_by.name} • ${createdAt}`
    : createdAt;

  return (
    <div className="t-flex t-justify-between t-items-start t-gap-4 sm:t-flex-col sm:t-gap-2 t-py-3 t-border-0 t-border-b t-border-dashed t-border-neutral-10 last:t-border-b-0">
      <div className="t-flex t-flex-col t-gap-1 t-min-w-0">
        <p className="t-m-0 t-break-words t-text-body-sm t-text-text-60 t-whitespace-pre-wrap">
          {changeRequest.reason}
        </p>
        <span className="t-text-body-sm-italic t-italic t-text-text-30">
          {requestedBy}
        </span>
      </div>
      <span className="t-shrink-0 t-whitespace-nowrap">
        <Tag tagType={isPending ? "red" : "green"} icon={false} rounded>
          {isPending ? "Request pending" : "Request resolved"}
        </Tag>
      </span>
    </div>
  );
};

export const ChangeRequestsAccordion = ({
  changeRequests,
}: ChangeRequestsAccordionProps) => (
  <Accordion.Root defaultValue={ACCORDION_VALUE} collapsible type="single">
    <Accordion.Item value={ACCORDION_VALUE}>
      <Accordion.Trigger>Changes requested</Accordion.Trigger>
      <Accordion.Content>
        <div className="t-flex t-flex-col">
          {changeRequests.map((changeRequest) => (
            <ChangeRequestItem
              key={changeRequest.uuid}
              changeRequest={changeRequest}
            />
          ))}
        </div>
      </Accordion.Content>
    </Accordion.Item>
  </Accordion.Root>
);
